import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { AuthorizationService } from "app/core/authorization.service";
import { ErrorMessageService } from "app/core/error-message.service";
import { Observable, catchError, forkJoin, map, of, switchMap } from "rxjs";
import { CurrentUserService } from "../shared/services/current-user.service";
import { RequestService } from "../shared/services/request.service";
import { CommentService } from "../shared/services/comment.service";
import { StatusService } from "../shared/services/status.service";

@Injectable({
  providedIn: "root",
})
export class ListResolver {
  constructor(
    private requestService: RequestService,
    private currentUserService: CurrentUserService,
    private errorMessageService: ErrorMessageService,
    private authorizationService: AuthorizationService,
    private statusService: StatusService,
    private commentService: CommentService,
  ) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean> {
    return this.fetchDatas().pipe(
      map((r) => true),
      catchError((error) => {
        if (error.status === 403) {
          this.authorizationService.setIsAuthorized(false);
          return of();
        }
        console.error({
          error,
          title: `Erreur survenue dans ListResolver. Voir propriété "error" pour plus d'info`,
        });
        this.errorMessageService.notifyCustomError(
          new Error(
            `<p>Erreur lors du démarrage.</p><p>Veuillez fermer l'application et la réouvrir.</p>`,
          ),
        );
        return of();
      }),
    );
  }

  fetchDatas() {
    return (
      this.currentUserService.allowableActivitiesFetched()
        ? of([])
        : this.currentUserService.setAllowableActivities()
    ).pipe(
      switchMap((_) =>
        forkJoin([
          this.currentUserService.allowableResponsibleUsersFetched()
            ? of([])
            : this.currentUserService.setAllowableResponsibleUsers(),
          this.requestService.getGeojsonObservable(),
          // These are not required for showing the map/list
          // but will ease things when showing workorder detail
          //
          // This will not impact application startup time
          // since it is done in parallel with slower call
          // (see getGeojsonObservable above)
          this.statusService.getAllStatuses(),
          this.commentService.getAllComments(),
        ]),
      ),
    );
  }
}
